import React, { useEffect } from "react"
import { Box, Grid } from "@mui/material"
import PageContainer from "src/components/page/PageContainer"
import BiPage from "./BiPage"
import { postTabletVisited } from "src/services/api/metrics"

const DashboardsPage: React.FC = () => {
  useEffect(() => {
    postTabletVisited("BI")
  }, [])

  return (
    <PageContainer>
      <Grid item xs={12} sx={{ p: 8 }}>
        <Box>
          <BiPage />
        </Box>
      </Grid>
    </PageContainer>
  )
}

export default DashboardsPage
